"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isDev;
/**
 * Returns if the environment is development or not
 * When true it calls the given callback if there is one
 * @param {function} [cb]
 * @returns {boolean}
 */
function isDev(cb) {
  if (process.env.NODE_ENV !== 'production') {
    cb && cb();
    return true;
  }
  return false;
}